/**
 * Whether the Doorman greeting needs asking for.
 *
 * Under the Doorman the greeting is quick-action BUTTONS pushed over the
 * WebSocket, not prose — and the backend only emits them in response to
 * /reader/welcome/. Anything that clears the canvas and expects the menu to
 * reappear has to ask for it; nothing arrives unprompted.
 *
 * Shared by the finish-reading teardown and the chat-drawer safety repaint,
 * which had independently grown the same condition.
 */
export function needsGreetingRepaint (surface) {
  if (!surface || !surface.hasSession) return false
  // Something is already on screen — repainting would duplicate the menu or
  // interrupt what the seeker is doing.
  if ((surface.messageCount || 0) > 0) return false
  if ((surface.quickActionCount || 0) > 0) return false
  if (surface.showingReading) return false
  if (surface.selectingCards) return false
  return true
}
